/* eslint-disable @typescript-eslint/no-explicit-any */
import { Listbox } from '@headlessui/react'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

interface CategorySort {
  onChange: (e: { name: string; value: string | null }[]) => void
  className?: string
  classSelectButtonName?: string
  isError?: boolean | string
  isICon?: boolean
  selectContainClassName?: string
  sortOptions: any
  activeSort: any
  value?: any
  activeSortCustom: string[]
}
const CategorySort = ({
  sortOptions,
  onChange,
  className = '',
  activeSort = '',
  activeSortCustom = [''],
}: CategorySort) => {
  const router = useRouter()
  const [, setIsSelected] = useState(false)
  const [selectedValue, setSelectedValue] = useState<string[]>([])
  const sortOptionsData = sortOptions
    .filter((e: any) => e.type == 'custom')
    .map((item: any) => ({
      name: item.name,
      value: null,
    }))

  useEffect(() => {
    const checkSortActive = sortOptions
      .filter((e: any) => e.type == 'custom')
      .map((item: any) => {
        if (activeSortCustom.includes(item.name)) {
          return item
        }
        return null
      })
      .filter(Boolean)
    setSelectedValue(checkSortActive)
  }, [])
  const onChangeSortCustom = (by: any) => {
    setSelectedValue(by)
    const updatedArray = sortOptionsData.map((item: any) => {
      const match = by.find((elem: any) => elem.name === item.name)
      if (!match) {
        return { ...item, value: null }
      }
      return { ...item, value: true }
    })
    onChange(updatedArray)
    setIsSelected(true)
  }
  useEffect(() => {
    if (activeSort) {
      return setActiveSortButton(activeSort)
    }
    return setActiveSortButton('')
  }, [activeSort, router])

  function iconSort(e: string, active: boolean) {
    switch (e) {
      case 'shouldBuy':
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={19}
            height={19}
            viewBox='0 0 19 19'
            fill={active ? 'white' : 'black'}
          >
            <g clipPath='url(#clip0_1063_24165)'>
              <path d='M16.8775 15.1468L16.0737 5.01775C16.0236 4.36518 15.4717 3.85397 14.8172 3.85397H13.2294V3.7826C13.2294 1.86405 11.6686 0.303223 9.75006 0.303223C7.83152 0.303223 6.27068 1.86405 6.27068 3.7826V3.85397H4.68296C4.02845 3.85397 3.47653 4.36514 3.42661 5.01638L2.62252 15.1482C2.56029 15.9594 2.84172 16.7671 3.39459 17.364C3.94745 17.9608 4.73119 18.3032 5.54481 18.3032H13.9553C14.7689 18.3032 15.5526 17.9609 16.1055 17.364C16.6584 16.767 16.9398 15.9594 16.8775 15.1468ZM7.32502 3.7826C7.32502 2.44543 8.41293 1.35756 9.75006 1.35756C11.0872 1.35756 12.1751 2.44547 12.1751 3.7826V3.85397H7.32502V3.7826ZM15.332 16.6475C14.9728 17.0353 14.4839 17.2489 13.9553 17.2489H5.54485C5.01624 17.2489 4.52735 17.0353 4.16813 16.6475C3.80894 16.2597 3.63337 15.7559 3.67373 15.2302L4.47775 5.09836C4.48591 4.99177 4.57605 4.9083 4.68296 4.9083H6.27068V6.2068C6.27068 6.49793 6.50672 6.73397 6.79785 6.73397C7.08898 6.73397 7.32502 6.49793 7.32502 6.2068V4.9083H12.1751V6.2068C12.1751 6.49793 12.4111 6.73397 12.7023 6.73397C12.9934 6.73397 13.2294 6.49793 13.2294 6.2068V4.9083H14.8172C14.9241 4.9083 15.0142 4.9918 15.0225 5.09977L15.8264 15.2288C15.8668 15.7559 15.6912 16.2597 15.332 16.6475Z' />
              <path d='M12.125 9.24291C11.9192 9.03703 11.5854 9.03703 11.3796 9.24291L9.02564 11.5968L8.12051 10.6917C7.91467 10.4858 7.58086 10.4858 7.37499 10.6917C7.16911 10.8976 7.16911 11.2313 7.37499 11.4372L8.65288 12.7151C8.75582 12.8181 8.89075 12.8696 9.02561 12.8696C9.16047 12.8696 9.29543 12.8181 9.39833 12.7151L12.125 9.98847C12.3309 9.78256 12.3309 9.44878 12.125 9.24291Z' />
            </g>
            <defs>
              <clipPath id='clip0_1063_24165'>
                <rect
                  width={18}
                  height={18}
                  fill='white'
                  transform='translate(0.75 0.303223)'
                />
              </clipPath>
            </defs>
          </svg>
        )
      case 'bestSelling':
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={18}
            height={19}
            viewBox='0 0 18 19'
            fill={active ? 'white' : 'black'}
          >
            <g clipPath='url(#clip0_1063_24175)'>
              <path d='M16.8031 9.5363C16.7306 9.38812 16.7306 9.21818 16.8031 9.07003L17.4744 7.69666C17.8482 6.93198 17.552 6.02056 16.8002 5.62164L15.4498 4.90516C15.3042 4.82789 15.2043 4.69036 15.1758 4.52797L14.9117 3.02228C14.7646 2.18394 13.9891 1.6206 13.1466 1.73982L11.633 1.95392C11.4696 1.97698 11.3081 1.92446 11.1896 1.80981L10.0909 0.746976C9.47915 0.15516 8.5208 0.155124 7.90908 0.746976L6.81038 1.80992C6.69184 1.9246 6.5303 1.97702 6.36696 1.95402L4.85339 1.73992C4.01052 1.62064 3.23533 2.18405 3.08827 3.02238L2.82418 4.52801C2.79567 4.69043 2.69579 4.82793 2.55014 4.90523L1.1998 5.62171C0.447948 6.02059 0.151793 6.93209 0.525573 7.69676L1.19688 9.0701C1.2693 9.21828 1.2693 9.38823 1.19688 9.53637L0.525537 10.9097C0.151758 11.6744 0.447913 12.5858 1.19976 12.9847L2.5501 13.7012C2.69579 13.7785 2.79567 13.916 2.82418 14.0784L3.08827 15.5841C3.22215 16.3473 3.87654 16.8825 4.62863 16.8824C4.70271 16.8824 4.77787 16.8772 4.85342 16.8665L6.367 16.6524C6.53023 16.6292 6.69187 16.6819 6.81042 16.7965L7.90908 17.8594C8.21501 18.1553 8.60742 18.3032 8.99997 18.3032C9.39242 18.3032 9.78508 18.1552 10.0909 17.8594L11.1896 16.7965C11.3081 16.6819 11.4697 16.6295 11.633 16.6524L13.1466 16.8665C13.9895 16.9858 14.7646 16.4224 14.9117 15.5841L15.1758 14.0784C15.2043 13.916 15.3042 13.7785 15.4498 13.7012L16.8002 12.9847C17.552 12.5858 17.8482 11.6744 17.4744 10.9097L16.8031 9.5363ZM16.3136 12.0676L14.9632 12.7841C14.5327 13.0126 14.2374 13.4189 14.1532 13.899L13.8892 15.4047C13.8394 15.6883 13.5772 15.8788 13.292 15.8386L11.7784 15.6245C11.2957 15.5561 10.8181 15.7114 10.4677 16.0503L9.36904 17.1131C9.16211 17.3133 8.83787 17.3133 8.63087 17.1131L7.53221 16.0503C7.23612 15.7638 6.84906 15.6086 6.44497 15.6086C6.37093 15.6086 6.2963 15.6138 6.22155 15.6244L4.70798 15.8385C4.42301 15.8788 4.16057 15.6883 4.11079 15.4046L3.84666 13.8989C3.76242 13.4188 3.46718 13.0125 3.03663 12.7841L1.68628 12.0676C1.4319 11.9326 1.3317 11.6243 1.45816 11.3655L2.1295 9.99217C2.34353 9.55427 2.34353 9.05203 2.1295 8.61413L1.45816 7.24076C1.3317 6.98204 1.4319 6.67369 1.68628 6.53872L3.03663 5.82224C3.46715 5.59376 3.76242 5.18743 3.84662 4.70734L4.11072 3.20168C4.1605 2.91804 4.42269 2.72749 4.70791 2.76778L6.22148 2.98188C6.704 3.05019 7.18181 2.89491 7.53214 2.55604L8.63083 1.4932C8.83776 1.29302 9.16201 1.29302 9.369 1.4932L10.4677 2.55604C10.818 2.89494 11.2957 3.05019 11.7783 2.98188L13.2919 2.76778C13.5769 2.72746 13.8393 2.91804 13.8891 3.20168L14.1532 4.70738C14.2374 5.18747 14.5327 5.59384 14.9632 5.82224L16.3136 6.53872C16.5679 6.67369 16.6681 6.98204 16.5417 7.24076L15.8703 8.61409C15.6563 9.05196 15.6563 9.55427 15.8703 9.99214L16.5417 11.3655C16.6682 11.6243 16.568 11.9326 16.3136 12.0676Z' />
              <path d='M12.7928 5.51043C12.5902 5.30772 12.2614 5.30772 12.0587 5.51043L5.20721 12.362C5.0045 12.5647 5.0045 12.8934 5.20721 13.0961C5.30856 13.1974 5.44142 13.2481 5.57424 13.2481C5.70706 13.2481 5.83995 13.1975 5.94127 13.0961L12.7928 6.24456C12.9956 6.04181 12.9956 5.71318 12.7928 5.51043Z' />
              <path d='M6.92371 4.63147C5.87423 4.63147 5.02039 5.48531 5.02039 6.53479C5.02039 7.58428 5.87423 8.43812 6.92371 8.43812C7.97319 8.43812 8.82703 7.58428 8.82703 6.53479C8.82703 5.48531 7.97319 4.63147 6.92371 4.63147ZM6.92371 7.39992C6.44667 7.39992 6.05858 7.01183 6.05858 6.53476C6.05858 6.05772 6.44667 5.66963 6.92371 5.66963C7.40074 5.66963 7.78887 6.05772 7.78887 6.53476C7.78884 7.01183 7.40074 7.39992 6.92371 7.39992Z' />
              <path d='M11.0763 10.1683C10.0268 10.1683 9.17297 11.0222 9.17297 12.0717C9.17297 13.1211 10.0268 13.975 11.0763 13.975C12.1258 13.975 12.9796 13.1211 12.9796 12.0717C12.9796 11.0222 12.1258 10.1683 11.0763 10.1683ZM11.0763 12.9368C10.5993 12.9368 10.2111 12.5487 10.2111 12.0717C10.2111 11.5946 10.5992 11.2065 11.0763 11.2065C11.5533 11.2065 11.9414 11.5946 11.9414 12.0717C11.9414 12.5487 11.5533 12.9368 11.0763 12.9368Z' />
            </g>
            <defs>
              <clipPath id='clip0_1063_24175'>
                <rect
                  width={18}
                  height={18}
                  fill='white'
                  transform='translate(0 0.303223)'
                />
              </clipPath>
            </defs>
          </svg>
        )
      case 'allowInstallment':
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={18}
            height={19}
            viewBox='0 0 18 19'
            fill={active ? 'white' : 'black'}
          >
            <g clipPath='url(#clip0_1063_24191)'>
              <path d='M17.437 11.5531C17.1265 11.5531 16.8745 11.8051 16.8745 12.1156V16.0531H1.12451V9.3031H7.31201C7.62251 9.3031 7.87451 9.0511 7.87451 8.7406C7.87451 8.4301 7.62251 8.1781 7.31201 8.1781H1.12451V5.9281H7.31201C7.62251 5.9281 7.87451 5.6761 7.87451 5.3656C7.87451 5.0551 7.62251 4.8031 7.31201 4.8031H1.12451C0.503512 4.8031 -0.000488281 5.3071 -0.000488281 5.9281V16.0531C-0.000488281 16.6741 0.503512 17.1781 1.12451 17.1781H16.8745C17.4955 17.1781 17.9995 16.6741 17.9995 16.0531V12.1156C17.9995 11.8051 17.7475 11.5531 17.437 11.5531Z' />
              <path d='M5.06201 11.5531H2.81201C2.50151 11.5531 2.24951 11.8051 2.24951 12.1156C2.24951 12.4261 2.50151 12.6781 2.81201 12.6781H5.06201C5.37251 12.6781 5.62451 12.4261 5.62451 12.1156C5.62451 11.8051 5.37251 11.5531 5.06201 11.5531Z' />
              <path d='M17.6586 3.16056L13.7211 1.47306C13.5783 1.41344 13.4196 1.41344 13.2768 1.47306L9.33926 3.16056C9.13339 3.24944 8.99951 3.45306 8.99951 3.67806V5.92806C8.99951 9.02294 10.1436 10.8319 13.2194 12.6038C13.306 12.6533 13.4028 12.6781 13.4995 12.6781C13.5963 12.6781 13.693 12.6533 13.7796 12.6038C16.8554 10.8364 17.9995 9.02744 17.9995 5.92806V3.67806C17.9995 3.45306 17.8656 3.24944 17.6586 3.16056ZM16.8745 5.92806C16.8745 8.52569 16.015 9.95556 13.4995 11.4631C10.984 9.95219 10.1245 8.52231 10.1245 5.92806V4.04931L13.4995 2.60256L16.8745 4.04931V5.92806Z' />
              <path d='M15.5392 4.92575C15.2974 4.7345 14.9441 4.77162 14.7484 5.0135L12.9799 7.22525L12.2801 6.179C12.1057 5.92025 11.7559 5.85162 11.5005 6.02262C11.2429 6.19475 11.172 6.54462 11.3441 6.80225L12.4691 8.48975C12.5692 8.63937 12.7335 8.73162 12.9135 8.74062C12.9214 8.74062 12.9304 8.74062 12.9371 8.74062C13.107 8.74062 13.269 8.66412 13.377 8.52912L15.627 5.71662C15.8205 5.47362 15.7822 5.12037 15.5392 4.92575Z' />
            </g>
            <defs>
              <clipPath id='clip0_1063_24191'>
                <rect
                  width={18}
                  height={18}
                  fill='white'
                  transform='translate(-0.000488281 0.303223)'
                />
              </clipPath>
            </defs>
          </svg>
        )
      case 'asc':
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={21}
            height={13}
            viewBox='0 0 21 13'
            fill={active ? 'white' : 'black'}
          >
            <path d='M4.85511 12.2819L4.85511 2.33261L7.09191 4.19659C7.73439 4.732 8.69808 3.92888 8.0556 3.39347L6.01533 1.69589L4.65332 0.562659C4.3882 0.34303 3.96001 0.34303 3.69488 0.562659L0.293941 3.39347C0.161134 3.50117 0.0866164 3.64942 0.0881577 3.80388C0.0882348 4.31374 0.833447 4.56396 1.25771 4.19659L3.49451 2.32818L3.49451 12.3113C3.54126 13.0965 4.90201 13.0379 4.85511 12.2819Z' />
            <rect
              x='10.1736'
              y='0.893311'
              width='10.4038'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.1736'
              y='3.52405'
              width='9.20333'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.1736'
              y='6.15466'
              width='7.37366'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.1736'
              y='8.78528'
              width='5.77872'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.1736'
              y='11.4159'
              width='3.90381'
              height='0.963968'
              rx='0.481984'
            />
          </svg>
        )
      case 'desc':
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={21}
            height={13}
            viewBox='0 0 21 13'
            fill={active ? 'white' : 'black'}
          >
            <path d='M4.93299 0.991006L4.93299 10.9403L7.16979 9.07636C7.81227 8.54095 8.77596 9.34407 8.13348 9.87948L6.09321 11.5771L4.7312 12.7103C4.46608 12.9299 4.03789 12.9299 3.77277 12.7103L0.371821 9.87948C0.239015 9.77178 0.164497 9.62353 0.166039 9.46907C0.166116 8.95921 0.911328 8.70899 1.33559 9.07636L3.57239 10.9448L3.57239 0.961691C3.61914 0.176461 4.9799 0.235091 4.93299 0.991006Z' />
            <rect
              x='10.2515'
              y='0.893311'
              width='10.4038'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.2515'
              y='3.52405'
              width='9.20333'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.2515'
              y='6.15466'
              width='7.37366'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.2515'
              y='8.78528'
              width='5.77872'
              height='0.963968'
              rx='0.481984'
            />
            <rect
              x='10.2515'
              y='11.4159'
              width='3.90381'
              height='0.963968'
              rx='0.481984'
            />
          </svg>
        )

      default:
        break
    }
  }

  const onPriceSort = (name: string) => {
    setActiveSortButton(name)
    if (name == activeSortButton) {
      setActiveSortButton('')
      return onChange([
        {
          name: 'sortBy',
          value: null,
        },
        {
          name: 'sortType',
          value: null,
        },
      ])
    }
    return onChange([
      {
        name: 'sortBy',
        value: 'calMediaPrice',
      },
      {
        name: 'sortType',
        value: name,
      },
    ])
  }
  const [activeSortButton, setActiveSortButton] = useState('')
  return (
    <div className={`relative flex items-center gap-2.5 text-sm ${className}`}>
      <Listbox
        as='div'
        value={selectedValue}
        onChange={onChangeSortCustom}
        horizontal
        multiple
      >
        <Listbox.Options className={`flex gap-2.5`} as='div' static>
          {sortOptions &&
            sortOptions
              .filter(
                (item: { name: string; label: string; type: string }) =>
                  item.type == 'custom'
              )
              .map((e: any, index: number) => (
                <Listbox.Option
                  key={`sort-${index}`}
                  as='div'
                  className={``}
                  value={e}
                >
                  <div
                    className={`flex h-10 cursor-pointer items-center gap-x-2.5 gap-y-1.5 rounded-lg border px-2 ${
                      e && e.name && activeSortCustom?.includes(e.name)
                        ? 'border-primary-base bg-primary-base text-white'
                        : 'border-dark-200 bg-white text-dark-400'
                    }`}
                  >
                    {iconSort(e.name, activeSortCustom?.includes(e.name))}
                    {e.label}
                  </div>
                </Listbox.Option>
              ))}
        </Listbox.Options>
      </Listbox>

      <div className={`flex gap-2.5`}>
        {sortOptions &&
          sortOptions
            .filter((item: any) => item.type == 'sortType')
            .map((e: any, index: number) => (
              <button
                key={`sort-${index}`}
                className={``}
                onClick={() => onPriceSort(e.name)}
              >
                <div
                  className={`flex h-10 cursor-pointer items-center gap-x-2.5 gap-y-1.5 rounded-lg border px-2 ${
                    activeSortButton == e.name
                      ? 'border-primary-base bg-primary-base text-white'
                      : 'border-dark-200 bg-white text-dark-400'
                  }`}
                >
                  {iconSort(e.name, activeSortButton == e.name)}
                  {e.label}
                </div>
              </button>
            ))}
      </div>
    </div>
  )
}

export default CategorySort
